import useTypographyMediaQuery from '../../hooks/useTypographyMediaQuery';
import Stack from '@mui/material/Stack';
import TableHeadTypography from '../TableHeadTypography';
import SortingArrow from '../SortingArrow';
import { sortingMethods } from 'src/constants/table';

const CustomCell = ({
  field,
  sortingCellField,
  sortFieldName,
  title,
  onCellSort,
  onDoubleClick,
  getCellSortMethod,
  hasSorting = false,
}) => {
  const { mediumScreen, largeScreen, smallScreen } = useTypographyMediaQuery();

  return (
    <Stack direction="row" gap={1} onDoubleClick={() => onDoubleClick(field)}>
      <TableHeadTypography
        hasSorting={getCellSortMethod(field, sortingCellField) !== sortingMethods.initial}
        mediumScreen={mediumScreen}
        largeScreen={largeScreen}
        smallScreen={smallScreen}>
        {title}
      </TableHeadTypography>
      {hasSorting && (
        <SortingArrow
          hasSorting
          onClick={() => {
            return onCellSort({
              field: field,
              sortingCellField: sortingCellField,
              sortMethod: getCellSortMethod(field, sortingCellField),
              sortFieldName: sortFieldName,
            });
          }}
          sortMethod={getCellSortMethod(field, sortingCellField)}
        />
      )}
    </Stack>
  );
};

export default CustomCell;
